import {
  BlackJackGameMode,
  DECISION_TYPE,
  INSURANCE_TYPE,
  SOCKET_DECISIONS_METHODS,
  SOCKET_INVOKE_TARGETS,
} from '../handBlackjackCore/constants';
import { checkHashStore } from '../../../store/checkHashStore';
import { cardsStore } from '../handBlackjackStore/cardsStore';
import { handBlackJackBetStore } from '../handBlackjackStore/betStore';
import { userInfoStore } from '../../../store/userInfoStore';
import { userSettingsStore } from '../../../store/userSettingsStore';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';
import { ValidationType } from '../../../core/constants/validationType';
import { notificationStore } from '../../../store/notificationStore';
import { handBlackJackGameConnection } from '../handBlackjackConnection';
import { blackJackBetsStore } from '../../blackjack/blackJackStore/betStore';
import { TranslationKeys } from '../../../core/constants/translationKeys';
import { betHistoryStore } from '../../../store/betHistoryStore';
import { HandBlackJackSoundsName } from '../handBlackjackCore/constants/sounds';
import { soundService } from '../../../services/baseSoundService/soundService';
import { freeBetStore } from '../../../store/freeBetStore';

class HandBlackJackGameService {
  onGetInitialStateResult({
    quickBets,
    maxWinLimit,
    lastSpinInfo,
    dealerCardInfo,
    spinInitialInfo,
    possibleSpinActionInfo,
    // displayQuickBets,
  }) {
    this.resetGameStoreData();
    const { currentFreeBet } = freeBetStore;
    if (lastSpinInfo) {
      checkHashStore.setLastRoundInfo(lastSpinInfo);
      checkHashStore.setLastRoundResult({
        openedCards: lastSpinInfo.openedCards,
        id: lastSpinInfo.id,
      });
    }
    blackJackBetsStore.setMaxWinLimit(maxWinLimit);
    if (dealerCardInfo) {
      cardsStore.setDealerCardsInfo(dealerCardInfo.dealerCards, dealerCardInfo.dealerPoint);
    }
    if (spinInitialInfo) {
      cardsStore.handleInitialStateByHand(spinInitialInfo.spinsInfo);
      handBlackJackBetStore.handleInitialBetsModel(spinInitialInfo.spinsInfo, quickBets[0]);
      // spinInitialInfo.insuranceSpin && handBlackJackBetStore.updateInsuranceAmount();
    }

    if (possibleSpinActionInfo.possibleActions) {
      handBlackJackBetStore.setActiveBox(possibleSpinActionInfo.boxIndex);
      handBlackJackBetStore.setActiveHandByBox(possibleSpinActionInfo.handType);
      handBlackJackBetStore.setPossibleActions(possibleSpinActionInfo.possibleActions);
      handBlackJackBetStore.setActiveBetId(possibleSpinActionInfo.spinId);
      handBlackJackBetStore.setIsDoSpinStart(true);
      handBlackJackBetStore.updateIsShowDecision(true);
      if (possibleSpinActionInfo.possibleActions.includes(INSURANCE_TYPE)) {
        if (currentFreeBet) {
          handBlackJackGameConnection.sendInsurance({
            isInsurance: false,
            spinId: possibleSpinActionInfo.spinId,
          });
        } else {
          handBlackJackBetStore.setIsInsuranceDecisionOpened(true);
        }
      }
      handBlackJackBetStore.setIsAllowSendDecision(true);
    }
    checkHashStore.setNextHashTextInfo(TranslationKeys.NextCards);
  }

  combineDecisionEvents = {
    [SOCKET_DECISIONS_METHODS.HitResult]: this.handleHitResult.bind(this),
    [SOCKET_DECISIONS_METHODS.StandResult]: this.handleStandResult.bind(this),
    [SOCKET_DECISIONS_METHODS.SplitResult]: this.handleSplitResult.bind(this),
    [SOCKET_DECISIONS_METHODS.DoubleResult]: this.handleDoubleResult.bind(this),
    [SOCKET_DECISIONS_METHODS.SurrenderResult]: this.handleSurrenderResult.bind(this),
    [SOCKET_DECISIONS_METHODS.InsuranceResult]: this.handleInsuranceResult.bind(this),
    [SOCKET_DECISIONS_METHODS.InsuranceInfoResult]: this.handleInsuranceInfoResult.bind(this),
  };

  handleDecisionEvents(eventName, data) {
    if (data.operatorError) {
      notificationStore.setOperatorError(data.operatorError);
    }
    if (data.responseCode === ValidationType.Success) {
      handBlackJackBetStore.updateIsShowDecision(false);
      handBlackJackBetStore.setIsSelectedDecision(false);
      handBlackJackBetStore.setIsInsurance(false);
      this.combineDecisionEvents[eventName](data);
    } else {
      handBlackJackBetStore.setIsAllowSendDecision(true);
      notificationStore.setNotification(data.responseCode);
    }
  }

  handleHitResult({ cardInfo, boxIndex }) {
    cardInfo.forEach((card) => {
      this.dealingCard({ boxIndex, ...card });
    });
  }

  handleStandResult({ handType, boxIndex }) {
    cardsStore.updateSelectedDecisionByBox({
      boxIndex,
      decision: DECISION_TYPE.stand,
      hand: handType,
      isRemoveSecondPoint: true,
    });
    handBlackJackBetStore.updateIsShowDecision(false);
  }

  handleDoubleResult({ cardInfo, freebetInfo, boxIndex, balance }) {
    handBlackJackBetStore.doubleBetAmountByAction(boxIndex);
    handBlackJackBetStore.updateIsShowDecision(false);
    if (!freebetInfo) {
      userInfoStore.setUserBalance(balance);
    }
    this.dealingCard({
      boxIndex,
      isDouble: true,
      decision: DECISION_TYPE.double,
      ...cardInfo[0],
    });
  }

  handleInsuranceInfoResult({ hasInsuranceAction }) {
    handBlackJackBetStore.setIsSelectedDecision(false);
    handBlackJackBetStore.setDealerInsuranceAnimationStart(true);
    handBlackJackBetStore.setIsInsurance(hasInsuranceAction);
    handBlackJackBetStore.setPossibleActions([]);
    handBlackJackBetStore.updateIsShowDecision(false);
  }

  handleInsuranceResult({ isInsurance, balance, winAmount }) {
    handBlackJackBetStore.setIsSelectedDecision(false);
    handBlackJackBetStore.setIsInsuranceDecisionOpened(false);
    handBlackJackBetStore.setDealerInsuranceAnimationStart(true);
    handBlackJackBetStore.setIsInsurance(isInsurance);
    if (isInsurance) {
      handBlackJackBetStore.updateInsuranceAmount();
      userInfoStore.setUserBalance(balance);
      if (!winAmount) {
        setTimeout(() => {
          handBlackJackBetStore.updateInsuranceAmount(true);
        }, 1000);
      }
    }
    handBlackJackBetStore.setPossibleActions([]);
    handBlackJackBetStore.updateIsShowDecision(false);
  }

  handleSplitResult({ boxIndex, freebetInfo, cardInfo, balance }) {
    handBlackJackBetStore.updateIsShowDecision(false);
    cardsStore.splitBoxByHand({ boxIndex });
    handBlackJackBetStore.doubleBetAmountByAction(boxIndex);
    cardInfo.forEach((card) => this.dealingCard({ boxIndex, ...card }));
    if (freebetInfo !== null) {
      freeBetStore.updateCurrentFreeBet(freebetInfo);
    }
    if (!freebetInfo) {
      userInfoStore.setUserBalance(balance);
    }
  }

  handleSurrenderResult({ boxIndex }) {
    handBlackJackBetStore.updateIsShowDecision(false);
    cardsStore.updateSurrenderResultByBox(boxIndex);
    // handBlackJackBetStore.updateSurrenderAmountByBox(boxIndex, amount);
  }

  dealingCard({ boxIndex, hasBlackJack, totalPoint, secondPoint, openedCard }) {
    this.handleActionResult({
      hasBlackJack,
      totalPoint,
      secondPoint,
      openedCard,
      boxIndex,
    });
  }

  handleActionResult({ hasBlackJack, boxIndex, totalPoint, secondPoint, openedCard }) {
    cardsStore.updateCards({ boxIndex, totalPoint, openedCard, secondPoint, hasBlackJack });
  }

  handleDoSpinResult({ responseCode, freebetInfo, balance }) {
    const { betsModels, setReBet } = handBlackJackBetStore;
    if (responseCode === ValidationType.Success) {
      setReBet(betsModels);
      handBlackJackBetStore.setIsDoSpinStart(true);
      if (freebetInfo !== null) {
        freeBetStore.updateCurrentFreeBet(freebetInfo);
      }
      if (!freebetInfo) {
        userInfoStore.setUserBalance(balance);
      }
    } else {
      handBlackJackBetStore.setIsDoSpinStart(false);
      notificationStore.setNotification(responseCode);
    }
  }

  handleCardResult(data) {
    this.dealingCard(data);
  }

  sendDecisionAction(type) {
    soundService.play(HandBlackJackSoundsName.decision);
    const model = {
      spinId: handBlackJackBetStore.activeBetId,
      mode: userSettingsStore.isTurboOn ? BlackJackGameMode.Turbo : BlackJackGameMode.Normal,
    };
    if (handBlackJackBetStore.isAllowSendDecision) {
      handBlackJackBetStore.setIsAllowSendDecision(false);
      handBlackJackGameConnection.sendDecisionAction(SOCKET_INVOKE_TARGETS[type], model);
    }
  }

  handleDecisionResult({ boxIndex, handType, spinId, possibleActions }) {
    const { currentFreeBet } = freeBetStore;
    handBlackJackBetStore.setActiveHandByBox(handType);
    handBlackJackBetStore.setIsAllowSendDecision(true);
    handBlackJackBetStore.updateIsShowDecision(true);
    handBlackJackBetStore.setActiveBetId(spinId);
    handBlackJackBetStore.setActiveBox(boxIndex);
    handBlackJackBetStore.setPossibleActions(possibleActions);
    if (possibleActions.includes(INSURANCE_TYPE)) {
      if (currentFreeBet) {
        handBlackJackGameConnection.sendInsurance({ isInsurance: false, spinId: spinId });
      } else {
        handBlackJackBetStore.setIsInsuranceDecisionOpened(true);
      }
    }
  }

  handleSpinResult({ newHash, totalWin, totalOdd, freebetInfo, calculatedSpins }) {
    const { spinId, key, salt, hash, openedCards, spins } = calculatedSpins;
    if (freebetInfo !== null) {
      freeBetStore.updateCurrentFreeBet(freebetInfo);
    }
    checkHashStore.setNextRoundHash(newHash);
    checkHashStore.setLastRoundInfo({ key, salt, hash });
    checkHashStore.setLastRoundResult({ openedCards, id: spinId });
    handBlackJackBetStore.setActiveBox(null);
    handBlackJackBetStore.setHandsOdds(spins);
    if (totalWin) {
      setTimeout(
        () => {
          soundService.play(HandBlackJackSoundsName.win);
          handBlackJackBetStore.setWinAmount(totalWin);
          handBlackJackBetStore.setWinOdd(totalOdd);
          betHistoryStore.getLastBet(spins.length);
          setTimeout(
            () => {
              userInfoStore.getBalance();
            },
            userSettingsStore.isTurboOn ? 500 : 0
          );
        },
        userSettingsStore.isTurboOn ? 700 : 1000
      );
    } else {
      setTimeout(
        () => {
          soundService.play(HandBlackJackSoundsName.lose);
          betHistoryStore.getLastBet(spins.length);
        },
        userSettingsStore.isTurboOn ? 500 : 0
      );
    }
    setTimeout(
      () => {
        this.resetGameStoreData();
        this.handleReBet();
      },
      userSettingsStore.isTurboOn ? 1500 : 3000
    );
  }

  doSpin() {
    const { lastBetModel, isDoSpinStart, setIsDoSpinStart } = handBlackJackBetStore;
    const model = {
      spinData: lastBetModel.betModel,
      mode: userSettingsStore.isTurboOn ? BlackJackGameMode.Turbo : BlackJackGameMode.Normal,
    };
    if (!isDoSpinStart) {
      soundService.play(HandBlackJackSoundsName.bet);
      mainGameConnection.doSpin(model, false);
    }
    setIsDoSpinStart(true);
  }

  handleReBet() {
    const { reBet, setBetsModel, betsTotalAmount } = handBlackJackBetStore;
    if (reBet && betsTotalAmount <= userInfoStore.userBalance) {
      setBetsModel(reBet);
    }
  }

  resetGameStoreData() {
    cardsStore.resetCards();
    cardsStore.setBoxCount(3);
    handBlackJackBetStore.handleToInitStore();
  }
}

export const handBlackJackGameService = new HandBlackJackGameService();
